import { takeLatest, call, put } from "redux-saga/effects";
import {
  PARTNER_PAGE_LOAD,
  partnerLogoLoad,
  partnerPageLoaded,
} from "../../actions/partners";
import getPartner from "../../../../../backend/oncall/administration/partners/get-by-id";
import { showErrorPage } from "sc/actions/ui/location";

const partnerPageLoadSaga = function*(action) {
  try {
    if (action.payload.partnerId === undefined) {
      // These are the default values on the add page.
      yield put(
        partnerPageLoaded({
          partnerId: "",
          name: "",
          internalId: "",
          enabled: true,
          logo: "",
          queues: [],
        }),
      );
      return;
    }
    const result = yield call(getPartner, action.payload.partnerId);
    yield put(partnerPageLoaded(result));
    if (result.logo) {
      yield put(partnerLogoLoad(result.logo));
    }
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNER_PAGE_LOAD, partnerPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/edit-page-load.js